const DEFAULT_API = "https://lk.e-mind.ru/api";
const DEFAULT_SERVER = "https://lk.e-mind.ru";

/** Базовый URL REST API (переопределение: REACT_APP_API_URL). */
export const API = (process.env.REACT_APP_API_URL || DEFAULT_API).replace(/\/$/, "");

/** Происхождение сайта для статики/аватаров (переопределение: REACT_APP_SERVER_URL). */
export const SERVER_URL = (process.env.REACT_APP_SERVER_URL || DEFAULT_SERVER).replace(/\/$/, "");

/** Публичный URL ЛК для ссылок (переопределение: REACT_APP_SITE_URL). */
export const SITE_URL = process.env.REACT_APP_SITE_URL || SERVER_URL;

/**
 * Путь WebSocket на публичном домене (nginx проксирует на Node ws-server).
 * ЛК открывается как `/lk`, REST как `/api` — сокет отдельно: `wss://домен/ws`, без префикса `/api`.
 */
export const REALTIME_WS_PATH = "/ws";

/**
 * Полный URL WebSocket для браузера: тот же host, что у страницы, путь {@link REALTIME_WS_PATH}.
 * Переопределение для dev: `REACT_APP_WS_URL` (например `ws://127.0.0.1:9003/ws`, если nginx нет).
 */
export function getRealtimeWebSocketUrl(): string {
    const fromEnv = process.env.REACT_APP_WS_URL?.trim().replace(/\/$/, "");
    if (fromEnv) {
        return fromEnv;
    }
    if (typeof window === "undefined") {
        return `ws://127.0.0.1:9003${REALTIME_WS_PATH}`;
    }
    const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${wsProtocol}//${window.location.host}${REALTIME_WS_PATH}`;
}
